import { isBefore, addMonths } from 'date-fns'

export const getFormattedExpiration = (expMonth: string, expYear: string) =>
    `${expMonth}/${expYear.slice(-2)}`
  

export const isCardExpired = (expMonth: string, expYear: string) => {
  const currDate = new Date()
  const expDate = new Date(parseInt(expYear), parseInt(expMonth), 1)

  // assure true is only returned after expiration month and year
  return isBefore(addMonths(expDate, 1), currDate)
}
